import React from 'react';

import ClassSessionContainer from './ClassSessionContainer';
import { ClassSessionDetail } from './ClassSessionDetail';

const ClassSessionPage: React.FC = () => (
    <ClassSessionContainer.Provider>
        <ClassSessionDetail/>
    </ClassSessionContainer.Provider>
);
export default ClassSessionPage;
